import { useSyncExternalStore } from "react";

const subscribe = (onChange) => {
   document.addEventListener("visibilitychange", onChange);
   return () => document.removeEventListener("visibilitychange", onChange);
};

const getSnapshot = () => document.visibilityState === "visible";

const getServerSnapshot = () => true;

/**
 * Tracks whether the browser tab is currently visible.
 * @returns {boolean} True while document.visibilityState is "visible"
 */
const useIsTabVisible = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useIsTabVisible;
